// import {} from "./DashboardPage.styles";
import { useTranslation } from "react-i18next";
import Screen from "../../components/Screen";
import { Description, Title, Wrapper } from "./DashboardPage.styles";
import { useEffect } from "react";
import { useStore } from "../../store/store";

export default function DashboardPage() {
  const { t } = useTranslation();
  const setActiveMenuId = useStore.useSetActiveMenuId();

  useEffect(() => {
    setActiveMenuId(undefined);
  }, []);

  return (
    <Screen isAnimated>
      <Wrapper>
        <Title>{t("dashboardPage.title")}</Title>
        <Description>{t("dashboardPage.description")}</Description>
      </Wrapper>
    </Screen>
  );
}
